export default __webpack_public_path__ + "static/media/0x1e991ea872061103560700683991a6cf88ba0028.5a276b87.svg";